import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/autoplay";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import NorthEastIcon from "@mui/icons-material/NorthEast";

import interiorIcon from "../../assets/icons/paint-brush.png";
import exteriorIcon from "../../assets/icons/home-maintenance.png";
import commercialIcon from "../../assets/icons/new-house.png";
import textureIcon from "../../assets/icons/color-selection.png";
import woodPolishIcon from "../../assets/icons/handcraft.png";
import waterproofIcon from "../../assets/icons/crack.png";
import "./PainterServiceSections.css";

const paintingTypes = [
  {
    iconPath: interiorIcon,
    title: "Interior Painting",
    description: "Smooth, elegant finishes for every room in your home.",
    link: "/interior-painting-service/",
  },
  {
    iconPath: exteriorIcon,
    title: "Exterior Painting",
    description: "Weatherproof coatings that protect and beautify facades.",
    link: "/exterior-painting-service/",
  },
  {
    iconPath: commercialIcon,
    title: "Commercial Painting",
    description: "Durable, fast-turnaround painting for offices and shops.",
    link: "/commercial-painting-service/",
  },
  {
    iconPath: textureIcon,
    title: "Texture & Speciality",
    description: "Designer textures and accent walls with a premium look.",
    link: "/specality-painting-service/",
  },
  {
    iconPath: woodPolishIcon,
    title: "Wood Polishing",
    description: "Restore the natural shine of doors, furniture and frames.",
    link: "#enquiry-section",
  },
  {
    iconPath: waterproofIcon,
    title: "Waterproof Coating",
    description: "Long-lasting protection against leaks and seepage.",
    link: "#enquiry-section",
  },
];

const OurPaintingServices = () => {
  return (
    <div className="pnt-services-wrap">
      <Swiper
        modules={[Navigation, Autoplay]}
        spaceBetween={20}
        navigation={{
          nextEl: ".pnt-services-next",
          prevEl: ".pnt-services-prev",
        }}
        autoplay={{
          delay: 3200,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        }}
        loop={true}
        breakpoints={{
          320: { slidesPerView: 1.3, spaceBetween: 14 },
          600: { slidesPerView: 2.2, spaceBetween: 16 },
          960: { slidesPerView: 3, spaceBetween: 20 },
          1280: { slidesPerView: 4, spaceBetween: 22 },
        }}
      >
        {paintingTypes.map((item, index) => (
          <SwiperSlide key={index}>
            <a href={item.link} className="pnt-service-card">
              <span className="pnt-service-index">{String(index + 1).padStart(2, "0")}</span>
              <div className="pnt-service-icon">
                <img src={item.iconPath} alt={item.title} loading="lazy" />
              </div>
              <h3 className="pnt-service-title">{item.title}</h3>
              <p className="pnt-service-desc">{item.description}</p>
              <span className="pnt-service-link">
                Explore Service <NorthEastIcon fontSize="inherit" />
              </span>
            </a>
          </SwiperSlide>
        ))}
      </Swiper>

      <button className="pnt-services-nav pnt-services-prev" aria-label="Previous services">
        <ArrowBackIcon fontSize="small" />
      </button>
      <button className="pnt-services-nav pnt-services-next" aria-label="Next services">
        <ArrowForwardIcon fontSize="small" />
      </button>
    </div>
  );
};

export default OurPaintingServices;
